module.exports = __webpack_public_path__ + "img/success.61cefc33.png";